import React, {useEffect, useMemo, useState, useRef} from 'react'
import {
    Table,
    // IconStar,
    Button,
    IconSearch,
    DropDownNew,
    DropDownSub,
    IconFilter,
    useWindowDimensions,
    IconSignPlus
} from '@Knowledge-OTP/znk-ui-components'
import Pagination from '../../common/Pagination'
import {
    InputGroup,
    // InputGroupAddon,
    // InputGroupText,
    TabPane, TabContent
  } from 'reactstrap'
import {useQuery, gql} from '@apollo/client'
import PlanTableSkeleton from '../Plans/Skeleton'
import useResponsivePlanColumns from './Columns/useResponsivePlanColumns'
import useNewPlanModal from './Modal/newPlanModal/useNewPlanModal'
import useViewPlanModal from './Modal/viewPlanModal/useViewPlanModal'
import useCounselingPlanReducer from '../../reducers/counseling-plan'
import usePlans from './Model/usePlans'
import StatusesFilter from '../Plans/Filters/Statuses'
import TypesFilter from './Filters/Types'
import GraduationFilter from './Filters/Graduation'
import CountryFilter from './Filters/Country'
import CounselorFilter from './Filters/Counselor'
import HeadFilter from './Filters/Head'
import TagsFilter from '../Payments/Filters/Tags'
import FilterBadge from '../../common/FilterBadge'

import useCounselingPlanList from './useCounselingPlanList'
import UseAllUsers from '../Calendar/Components/SelectUser/Model/UseAllUsers'
//MAILS LIST
import useModalEmailsList from '../../common/ModalEmailsList/useModalEmailsList'
import useExcelDownload from '../../common/ExcelDownload/useExcelDownload'
import ExcelDownloadComponent from '../../common/ExcelDownload'
import OptionsEmailsAndDownloads from '../../common/ModalEmailsList/Components/Options'
import { useSelector } from 'react-redux'
import NoAuthorize from '../../common/NoAuthorize'
import useTranslation from '../../i18n/useTranslation'

import StartDateFilter from '../Plans/Filters/StartDate'
import ModalFilterMobile from './Filters/ModalFilterMobile'
// import AtomicFilter from '../Plans/Filters/atomicFilter'
import useAllClassOf from './Model/useAllClassOf'
import './index.css'
import NewActionButton from '../../common/NewActionButton'

const baseTypes = ['undergraduate', 'graduate', 'transfer', 'highSchool']
let arrayGraduationDates = []
// let countriesList = []
const baseStatuses = [
    'draft', 'sent',
    'cancel', 
    {
        id: 'inProgress', 
        multi: true, ids: ['scheduled', 'application', 'postApplication'], name: 'In Progress'
    }, //className: 'text-gray d-flex flex-row justify-content-start pl-1 mt-1 mb-2'},
    {id: 'scheduled', name: 'Pre Application', statusColor: 'warning-alt', className: `pl-6`}, 
    {id: 'application', name: 'Application', statusColor: 'inProgress', className: `pl-6`}, 
    {id: 'postApplication', name: 'Post Application', statusColor: 'primary-alt', className: `pl-6`}, 
    {id: 'completed', name: 'Completed', statusColor: 'success-alt'}
]

const normalizeStatuses = (statuses) => statuses.flatMap((status) => {
    const selectedStatus = baseStatuses.find((item) => item?.id === status)
    return selectedStatus?.multi ? selectedStatus.ids : [status]
})

const CounselingPlans = () => {
    const { staffInfo } = useSelector((state) => state.user)
    const isPermited  = staffInfo?.permissions?.filter(e => e.isPermited)?.map(per => {return per.tag})?.includes('counseling-plans');
    const { translate } = useTranslation()
    const {breakWidth} = useWindowDimensions()
    const {open: openNewPlanModal, /**setOpenToEdit**/} = useNewPlanModal()
    const {open: openViewPlanModal} = useViewPlanModal()
    const [loadingExcelInfo, setLoadingExcelInfo] = useState(false)
    const { dataClassOf } = useAllClassOf()
    // const [getDataUsers, {loading: loadingUsersExcel}] = useDownLoadExcelUsers()
    // const {open: openViewPlanModal} = useViewPlanModal()
    const {parsePlanFromAPI} = useCounselingPlanReducer()
    //objeto con filtros aplicados a listado de planes
    const [filters, setFilters] = useState({
        //pagination
        limit: 10,
        previous: null,
        next: null,
        //filters
        search: '',
        kind: ["counceling"],
        status: baseStatuses
        //descarte labels
        .filter((item) => typeof item === 'string' || (typeof item !== 'string' && !!item?.id && !item?.multi))
        .map((item) => item?.id || item)
        .filter((status) => !['cancel', 'completed']?.includes(status)),
        type: baseTypes,
        classOf: [],
        tags: [],
        countryIds: [],
        counselorIds: [],
        headIds: [],
        //shortcuts
        finishSoon: false,
        pendingApproval: false,
        lastApproved: false,
        previouslySent: false,
        shortRecenlySent: false,
        allPlans: true,
        isAtomic: undefined
    }) 

    
    const setShortCut = (shortcut) => {
        let auxFilter = {
            ...filters, 
            next: null,
            previous: null,
           //shortcuts
            finishSoon: false,
            pendingApproval: false,
            lastApproved: false,
            previouslySent: false,
            shortRecenlySent: false,
            allPlans: false
        }
        auxFilter[shortcut] = true
        setCurrentPage(1)
        setFilters(auxFilter)
    }

    //obtiene listado de planes desde API
    const {plans, refetch: refetchPlanList, paginatedData, loading} = usePlans(filters, {fetchPolicy: 'cache-first'})
    const {setRefetch} = useCounselingPlanList()
    // Modal lista de mails
    const { open: openEmailsListModal } = useModalEmailsList()
    const { open: openExcelDownloadModal } = useExcelDownload()
    const [execDownload, setExecDownload] = useState(false)
    //setea refetchPlanList en redux para ser ejecutado desde cualquier archivo
    useEffect(() => {
        if(refetchPlanList) {
            setRefetch(() => {refetchPlanList()})
        }
        // eslint-disable-next-line
    }, [refetchPlanList])

    //vuelve a ejecutar query
    useEffect(() => {
        //quita el shortcut `allPlans`
        const {allPlans, ...realFilters} = filters
        refetchPlanList(realFilters)
    }, [filters, refetchPlanList])
    
    //parsea listado de planes al formato del reduce (counselingPlanReduce)
    const planList = useMemo(() => {
        if( plans?.length > 0 ) return plans.map((plan) => {
            arrayGraduationDates = dataClassOf.sort((a, b) => a - b)
            return parsePlanFromAPI(plan)})
        return []

    }, [plans, parsePlanFromAPI, dataClassOf])

    const {data: dataCountries} = useQuery(gql`query{getAllCouncelingCountries{id name}}`)
    const countriesList = useMemo(() => dataCountries?.getAllCouncelingCountries || [], [dataCountries])

    // Fetch all users with SUPER_ADMIN role for counselor and head filters
    const [getAllUsers, { data: usersData }] = UseAllUsers()
    const counselorsList = useMemo(() => {
        if (!usersData?.allUsers?.docs) return []
        return usersData.allUsers.docs
            .map(user => ({
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName
            }))
    }, [usersData])

    const headsList = useMemo(() => {
        if (!usersData?.allUsers?.docs) return []
        return usersData.allUsers.docs
            .map(user => ({
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName
            }))
    }, [usersData])

    const filterBadgeOptions = [
        { id: 'startDate', name: 'Start date' },
        { id: 'counselor', name: 'Student Success Coordinator' },
        { id: 'headCounselor', name: 'Head Counselor' }
    ]
    const selectedFilterBadgeIds = [
        filters.startDateFilter?.length && 'startDate',
        filters.counselorIds?.length && 'counselor',
        filters.headIds?.length && 'headCounselor'
    ].filter(Boolean)
    // Fetch users on component mount
    useEffect(() => {
        getAllUsers({
            variables: {
                roles: ['SUPER_ADMIN'],
                limit: 1000, // Get all users
                sortField: 'firstName'
            }
        })
    }, [getAllUsers])

    const executeOnClickDownload = () => {
        openExcelDownloadModal(() => { }, "counselingPlan", filters)
        setExecDownload(true)
    }
    // const columns = useResponsivePlanColumns(planList, () => {
    //     refetchPlanList()
    // }, true)
    const columnsToTable = useResponsivePlanColumns(planList, () => {
        refetchPlanList()
    })
    const [currentPage, setCurrentPage] = useState(1)

    const searchInput = useRef(null) 
    if (!isPermited) {
        return <NoAuthorize />
    }     
    return (    
        <div className={`col-12 col-md-12 px-md-6 px-lg-7 d-flex flex-column justify-content-between`} style={{minHeight: '100%'}}>
            <div className={`d-flex flex-column m-0 p-0`}>
                <div className='container-fluid mt-2 mt-md-5 d-flex px-2 flex-column-reverse flex-md-row'>
                    <div className='d-flex flex-grow-1 align-items-center znk-scroll-horizontal mt-2 pr-0 pr-md-2 mt-md-0'>
                        {/* SHORTCUTS */}
                        <span onClick={() => {setShortCut('allPlans')}} className={`tab-link nav-title ${filters['allPlans'] ? 'active' : ''} m-0 mr-3 cursor-pointer`}>All plans</span>
                        <span onClick={() => {setShortCut('pendingApproval')}} className={`tab-link nav-title ${filters['pendingApproval'] ? 'active' : ''} m-0 mx-3 cursor-pointer`}>Pending approval</span>
                        <span onClick={() => {setShortCut('lastApproved')}} className={`tab-link nav-title ${filters['lastApproved'] ? 'active' : ''} m-0 mx-3 cursor-pointer`}>Last approved</span>
                        <span onClick={() => {setShortCut('finishSoon')}} className={`tab-link nav-title ${filters['finishSoon'] ? 'active' : ''} m-0 mx-3 cursor-pointer`}>Finish soon</span>
                    </div>
                    <div className='d-md-flex d-none align-items-center justify-content-end justify-content-md-start flex-row-reverse flex-md-row'>
                        <span>
                            <NewActionButton
                                className='w-auto counseling-plans-create-button'
                                label='New Plan'
                                onClick={() => {
                                openNewPlanModal(() => {
                                    refetchPlanList()
                                })
                                }}
                            />
                        </span>
                    </div>
                </div>
                <div className={`d-flex flex-row m-0 p-0 justify-content-between align-items-center`} style={{minHeight: '68px'}}>
                {
              breakWidth === 'SM' ?
                    <> 
                    <ModalFilterMobile 
                    setQuery={setFilters} query={filters} 
                    countries={[...new Set(countriesList)]} 
                    graduationDates={arrayGraduationDates} 
                    types={baseTypes}
                    statuses={baseStatuses}
                    counselors={counselorsList}
                    heads={headsList}
                >
                  <div className='hover-icon'><IconFilter size={20} className='text-disabled'/></div>
                </ModalFilterMobile> 
                <span>
                <NewActionButton
                    className='p-0 plans-action-button plans-create-button text-center'
                    label='New Plan'
                    onClick={() => {
                    openNewPlanModal(() => {
                        refetchPlanList()
                    })
                    }}
                />
                </span>
                </>
                : 

                  
                     <div className={`container-fluid mt-2 mb-4 mt-md-5 px-0 d-flex znk-scroll-horizontal`}>
                        <StatusesFilter
                            statuses={baseStatuses} 
                            statusFilters={filters.status} 
                            visualOnlyStatusIds={['inProgress']}
                            setStatusFilters={(newStatus) => {
                                setCurrentPage(1)
                                setFilters({
                                    ...filters, 
                                    status: normalizeStatuses(newStatus),
                                    previous: null,
                                    next: null,
                                })
                            }}
                        />
                        <TypesFilter
                            types={baseTypes} 
                            typesFilters={filters.type} 
                            setTypesFilters={(newTypes) => {
                                setCurrentPage(1)
                                setFilters({...filters, type: newTypes,
                                    previous: null,
                                    next: null,
                                })
                            }}/>
                        <GraduationFilter
                             graduationDates={arrayGraduationDates} 
                             graduationFilters={filters.classOf} 
                             setGraduationFilters={(newTypes) => {
                                setCurrentPage(1)
                                 setFilters({...filters, classOf: newTypes,
                                    previous: null,
                                    next: null,
                                })
                            }}/>
                        <TagsFilter 
                            {...{
                                tagsFilters: filters?.tags || [],
                                setTagsFilters: (tags) => {
                                    setFilters({ ...filters, tags: tags })
                                }
                            }}
                        />
                        <CountryFilter
                            countries={[...new Set(countriesList)]}
                            countryFilters={filters.countryIds}
                            setCountryFilters={(newTypes) => {
                                setCurrentPage(1)
                                setFilters({...filters, countryIds: newTypes,
                                    previous: null,
                                    next: null,
                                })
                            }}/>
                        <DropDownNew
                            className='m-0 p-0'
                            classNameMenu='px-3 pt-3 pb-4'
                            direction='bottomCenter'
                            hoverEnabled={false}
                            trigger={['click']}
                            menuProps={{ triggerSubMenuAction: 'click' }}
                            options={[
                                {
                                component: (
                                    <DropDownSub title={`Start Date`}>
                                    <StartDateFilter
                                        startDateFilter={filters.startDateFilter}
                                        setStartDateFilter={(start) => { setFilters({ ...filters, startDateFilter: start }) }}
                                        typeFilter='StartDate' />
                                    </DropDownSub>
                                )
                                },
                                // {
                                //     component: (
                                //       <DropDownSub title=" Atomic plans">
                                //         <AtomicFilter
                                //           {...{
                                //             atomicFilter: filters.isAtomic,
                                //             setAtomicFilter: (id) => {
                                //               setFilters({ ...filters, isAtomic: id });
                                //             },
                                //           }}
                                //         />
              
                                //         {}
                                //       </DropDownSub>
                                //     ),
                                //   },
                                  {
                                    component: (
                                      <DropDownSub title="Student Success Coordinator">
                                        <CounselorFilter
                                          counselorFilters={filters.counselorIds}
                                          setCounselorFilters={(newCounselors) => {
                                            setCurrentPage(1)
                                            setFilters({
                                              ...filters,
                                              counselorIds: newCounselors,
                                              previous: null,
                                              next: null,
                                            })
                                          }}
                                          counselors={counselorsList}
                                        />
                                      </DropDownSub>
                                    ),
                                  },
                                  {
                                    component: (
                                      <DropDownSub title="Head Counselor">
                                        <HeadFilter
                                          headFilters={filters.headIds}
                                          setHeadFilters={(newHeads) => {
                                            setCurrentPage(1)
                                            setFilters({
                                              ...filters,
                                              headIds: newHeads,
                                              previous: null,
                                              next: null,
                                            })
                                          }}
                                          heads={headsList}
                                        />
                                      </DropDownSub>
                                    ),
                                  },
                 
                        ]}
              >               
               <FilterBadge
                 title={translate('plans.filterTitle')}
                 options={filterBadgeOptions}
                 selectedIds={selectedFilterBadgeIds}
                 onClearFilters={() => {
                   setCurrentPage(1)
                   setFilters({
                     ...filters,
                     startDateFilter: [],
                     counselorIds: [],
                     headIds: [],
                     previous: null,
                     next: null,
                   })
                 }}
                 showArrow={false}
                 icon={(
                   <IconFilter
                     className='mr-2 text-gray'
                     color={selectedFilterBadgeIds.length > 0 ? '#696CFF' : undefined}
                     size={15}
                   />
                 )}
                 showOptionComponents
               />
          </DropDownNew> 
                     </div>
}
                    {/* <div style> */}
                    {/* <ButtonEmailsList 
                      onClick={() => { openEmailsListModal(() => {}, {...filters, limit: 0}, 'counselingPlan') }} 
                    /> */}
                    {/* </div> */}
                    <InputGroup className={`znk-card ${breakWidth === 'SM' ? 'w-auto' : 'w-auto'} flex-nowrap`} title={'Search'} >
                    <div className='d-flex flex-row position-relative users-table-search-wrapper'>    
                        <input
                            className="znk-input users-table-search form-control"
                            style={{ height: "35px" }}
                            placeholder={'Search'}
                            ref={searchInput}
                            onKeyUp={({key}) => {
                                if(key === 'Enter') {
                                    setCurrentPage(1)
                                    setFilters({
                                        ...filters,
                                        search: searchInput.current.value,
                                        next: null, previous: null
                                    })
                                    // setSearchValue(searchInput.current.value)
                                }
                            }}
                        />
                        <span className='addon users-table-search-icon' aria-hidden='true'>
                            <IconSearch size={14} className='text-gray' />
                        </span>
                    </div>
                    </InputGroup>

                    <OptionsEmailsAndDownloads 
                        options={[{title: translate('users.actions.emails'), onClick: () => { openEmailsListModal(() => { }, "counselingPlan", filters) } },
                                {title: translate('users.actions.download'), onClick: () => { executeOnClickDownload() }},
                        ]}
                    loading={loadingExcelInfo}
                />
                </div>
                <div className={`m-0 p-0`}>
                    <TabContent activeTab={loading ? 'loading' : 'table'}>
                        <TabPane tabId={`loading`}>
                            <div className={`p-0 m-2`}>
                                <PlanTableSkeleton count={filters?.limit || 10} />
                            </div>
                        </TabPane>
                        <TabPane tabId={`table`}>
                            <Table
                                loading={false}
                                tableData={planList}
                                columnList={columnsToTable}
                                style={{cursor: 'pointer'}}
                                onClick={(row) => {
                                    openViewPlanModal(() => {refetchPlanList()}, row)
                                }}
                            />
                        </TabPane>
                    </TabContent>
                </div>
            </div>
            <ExcelDownloadComponent loadingExcelInfo={loadingExcelInfo} setLoadingExcelInfo={setLoadingExcelInfo} 
            execDownload={execDownload} setExecDownload={setExecDownload}
            />
            {breakWidth === 'SM' && (
              <Button
                className='position-fixed p-0'
                color='primary'
                size='small'
                style={{ bottom: '15px', right: '80px', width: 'fit-content', boderRadius: '25px' }}
                label={
                  <span className='p-2'>
                    <IconSignPlus size={15} className={`m-3`} style={{ transform: 'rotate(45deg)' }} />
                  </span>
                }
                onClick={() => {
                  openNewPlanModal(() => {
                    refetchPlanList()
                  })
                }}
              />
            )}
            <Pagination
                style={{
                    bottom: '0px',
                    position: 'sticky',
                    backgroundImage: `linear-gradient(
                        to bottom, 
                        rgba(255, 255, 255, 0), 
                        rgba(255, 255, 255, 0.95) 25%
                    )`,
                    paddingTop: '15px'
                }}
                pageSize={filters?.limit || 10}
                changeSize={(limit) => {setFilters({...filters, limit})}}
                clickNext={() => {
                    if(paginatedData?.hasNext && !loading) {
                        setCurrentPage(currentPage+1)
                        setFilters({...filters, next: paginatedData?.next, previous: null})
                    }
                }}
                clickPrevious={() => {
                    if(paginatedData?.hasPrevious && !loading && currentPage > 1) {
                        setCurrentPage(currentPage-1)
                        setFilters({...filters, previous: paginatedData?.previous, next: null})
                    }
                }}
                loading={loading}
                hasPrevious={paginatedData?.hasPrevious}
                hasNext={paginatedData?.hasNext}
                activePage={currentPage}
                pageCount={Math.ceil((paginatedData.totalDocs/filters.limit) || 1)}
            />
        </div>
    )
}

export default CounselingPlans
